<template>
  <div id="main-area">
    <div
      id="app"
      v-if="!loading && !showAddToHomePopup && !showNotificationPopup"
    >
      <transition
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        name="fade"
        appear
      >
        <router-view />
      </transition>
    </div>

    <div class="loader-container" v-else>
      <loader-vue />
    </div>

    <!-- Global message -->
    <transition name="slide-up">
      <message-vue v-if="globalMessage !== ''" />
    </transition>

    <!-- PWA Popup -->
    <pwa-popup
      hOne="Add PSYBooks to "
      hTwo="your Home screen?"
      pOne="Access your PSYBooks app "
      pTwo="quickly and easily by adding it to your Home Screen."
      aOne="Add to Home Screen"
      aTwo="Don't Ask Again"
      v-if="showAddToHomePopup"
      @sendAnswer="homeScreenHandler"
    />

    <!-- Notification popup -->
    <pwa-popup
      hOne="Turn on Notifications"
      hTwo=""
      pOne="Be notified right away when"
      pTwo="you receive messages"
      aOne="Turn On"
      aTwo="Don't Ask Again"
      v-if="showNotificationPopup"
      @sendAnswer="notificationHandler"
    />

    <div id="landscape-content">
      <div class="orientation-message">
        <h2>The app works best in portrait view. Please rotate your device!</h2>
        <p>Thank you!</p>
      </div>
    </div>
  </div>
</template>

<script>
import "./assets/css/styles.css";
import "./assets/css/pysbook-theme.css";
import { mapGetters, mapMutations, mapActions } from "vuex";
import LoaderVue from "./components/Appointment/common/Loader.vue";
import MessageVue from "./components/common/Message.vue";
import PwaPopup from "./components/common/PwaPopup";

export default {
  name: "App",
  computed: {
    ...mapGetters({
      loading: "getGlobalLoading",
      globalMessage: "getGlobalMessage",
      showAddToHomePopup: "getShowAddToHomePopup",
      showNotificationPopup: "getShowNotificationPopup",
      getInitialLoadRoute: "getInitialLoadRoute"
    })
  },
  components: {
    LoaderVue,
    MessageVue,
    PwaPopup
  },
  methods: {
    ...mapMutations({
      beforeEnter: "beforeRouteAnimating",
      afterEnter: "afterRouteAnimating",
      setShowNotificationPopup: "setShowNotificationPopup",
      setShowAddToHomePopup: "setShowAddToHomePopup",
      setInitialLoadRoute: "setInitialLoadRoute"
    }),
    ...mapActions({
      sendRefreshRequest: "sendRefreshRequest",
      fetchSecureVideoBaseUrl: "fetchSecureVideoBaseUrl",
      subscribeUser: "subscribeUser",
      addToHomeScreenAccept: "addToHomeScreenAccept",
      globalMessagePopup: "globalMessagePopup"
    }),
    /**
     * Add to home screen handler
     */
    homeScreenHandler(value) {
      this.setShowAddToHomePopup(false);
      if (value === "yes") {
        this.addToHomeScreenAccept();
      } else if (value === "dont_ask") {
        localStorage.setItem("addedToHomeScreen", value);
        // this.checkAndHandleNotification();
      }
    },

    /**
     * Function to check and handle notification
     */
    async checkAndHandleNotification() {
      const notificationPermission = localStorage.getItem(
        "notificationPermission"
      );
      if (notificationPermission === null) {
        this.setShowNotificationPopup(true);
      }

      if('accepted' === notificationPermission) {
        await this.subscribeUser();
      }
    },

    /**
     * Notification accepted handler
     */
    notificationHandler(value) {
      this.setShowNotificationPopup(false);
      if (value === "yes") {
        this.subscribeUser();
      } else if (value === "dont_ask") {
        localStorage.setItem("notificationPermission", value);
      }
    },
    checkIfMobile() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          // eslint-disable-next-line no-useless-escape
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  created() {
    // Send refresh request
    document.addEventListener("visibilitychange", async () => {
      this.sendRefreshRequest();
      try {
        if (this.checkIfMobile()) {

          if(
            (this.$router.currentRoute.name !== 'ComposeEmail') &&
            (!window.redirectRoute)
            /*(this.$router.currentRoute.name !== 'EmailDetail') &&
            (this.$router.currentRoute.name !== 'ChatId') &&
            (this.$router.currentRoute.name !== 'GroupChatId')*/
          ) {
            await this.$router.push({name: "Dashbord"});
          }

          window.redirectRoute = null;

        }
      } catch (_err) {
        // Do nothing
      }
    });

    // Get the the baseurl
    this.fetchSecureVideoBaseUrl();
  }
};
</script>

<style>
body {
  margin: 0px !important;
  padding: 0px !important;
}

#main-area {
  background-color: white;
}

.slide-up-enter-active {
  animation: slide-up 0.2s ease-in-out forwards;
}

.slide-up-leave-active {
  animation: slide-down 0.2s ease-in-out forwards;
}

@keyframes slide-up {
  from {
    bottom: -20px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}

@keyframes slide-down {
  from {
    bottom: 0;
    opacity: 1;
  }
  to {
    bottom: -20px;
    opacity: 0;
  }
}
</style>
